<template>
  <basic-container>
    <div class="fighter_container">
      <p class="fighter_container_title"> fighter - front </p>
      <ul>
        <li><a target="_blank" href="http://fighter.wiseloong.com/pc-front/06release/fighter-front-framework/docs/%E5%85%B6%E4%BB%96-%E5%89%8D%E7%AB%AF%E5%BC%80%E5%8F%91%E5%BC%BA%E5%88%B6%E8%A6%81%E6%B1%82.html">前端开发强制要求</a></li>
        <li><a target="_blank" href="http://fighter.wiseloong.com/pc-front/06release/fighter-front-framework/docs/Fighter%E6%A1%86%E6%9E%B6-%E4%BD%BF%E7%94%A8%E6%AD%A5%E9%AA%A4.html">引入fighter框架</a></li>
        <li><a target="_blank" href="http://fighter.wiseloong.com/pc-front/06release/fighter-front-framework/docs/%E5%8A%9F%E8%83%BD-%E5%B8%B8%E7%94%A8%E9%85%8D%E7%BD%AE%E6%96%87%E4%BB%B6%E5%B1%9E%E6%80%A7%E8%AF%B4%E6%98%8E.html">常用配置文件属性说明</a></li>
        <li>当前导航菜单样式高亮配置：查看`./src/page/styles/common.scss`相关配置，并更改!</li>
      </ul>
      <!-- <UserSelect /> -->
    </div>
  </basic-container>
</template>

<script>
import UserSelect from '@/framework/components/user/select'
export default {
  data() {
    return {
    }
  },

  components: {
    UserSelect
  },

  mounted: function() {

  },
  methods: {}
}

</script>
<style lang="scss" scoped>
.fighter_container{
  &_title{
    text-align: center;
    font-size: 80px;
    font-weight: 600;
  }
  color: $mainBg;
}
</style>
